import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/qiyerenzheng.png'


const _withScopeId = n => (_pushScopeId("data-v-3c4e96fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = { class: "one" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img1"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black" }, null, -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "two" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "公司主营:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.company), 1),
      _hoisted_4,
      _hoisted_5,
      (_ctx.vipinfo.userimgurl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.vipinfo.userimgurl,
            alt: "",
            class: "img2"
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: "vip-title",
        style: _normalizeStyle({ color: _ctx.vipinfo.usercolor })
      }, _toDisplayString(_ctx.vipinfo.title) + _toDisplayString(_ctx.vipinfo.type == 2 ? "VIP会员" : ""), 5)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", null, _toDisplayString(_ctx.user.products), 1)
    ])
  ]))
}